import { useTranslation } from "react-i18next";
import { Menu, MenuItem } from "semantic-ui-react";

import { CUSTOMER_TYPES } from "models";
import { CustomerForm } from "modules/Appointments/components/NewAppointment/components/CustomerFormSection/components";

type CustomerTypeProps = {
  activeTab: CUSTOMER_TYPES;
  hasValidationError: boolean;
  isCustomerDriverPreselected: boolean;
  isCustomerOwnerPreselected: boolean;
  isCustomerContractorPreselected: boolean;
  handleCustomerTabChange: (value: CUSTOMER_TYPES) => void;
};

export const CustomerType = ({
  activeTab,
  hasValidationError,
  isCustomerOwnerPreselected,
  isCustomerDriverPreselected,
  isCustomerContractorPreselected,
  handleCustomerTabChange
}: CustomerTypeProps) => {
  const { t } = useTranslation();

  const getIsCustomerPreselected = (type: CUSTOMER_TYPES) => {
    if (type === CUSTOMER_TYPES.Driver) return isCustomerDriverPreselected;
    if (type === CUSTOMER_TYPES.Owner) return isCustomerOwnerPreselected;
    if (type === CUSTOMER_TYPES.Contractor) return isCustomerContractorPreselected;
    return false;
  };

  return (
    <>
      <Menu tabular className="NewAppointment__Menu">
        <MenuItem active={activeTab === CUSTOMER_TYPES.Driver} onClick={() => handleCustomerTabChange(CUSTOMER_TYPES.Driver)}>
          {t("v8_driver", "Driver")}
        </MenuItem>
        <MenuItem active={activeTab === CUSTOMER_TYPES.Owner} onClick={() => handleCustomerTabChange(CUSTOMER_TYPES.Owner)}>
          {t("v8_owner", "Owner")}
        </MenuItem>
        <MenuItem active={activeTab === CUSTOMER_TYPES.Contractor} onClick={() => handleCustomerTabChange(CUSTOMER_TYPES.Contractor)}>
          {t("v8_customer_contractor", "Contractor")}
        </MenuItem>
      </Menu>
      <div className="NewAppointment__customer-group">
        <CustomerForm customerType={activeTab} hasValidationError={hasValidationError} isCustomerPreselected={getIsCustomerPreselected(activeTab)} />
      </div>
    </>
  );
};
